import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './styles/main.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Локал dev: TunedGlobal-ийн CORS-ийг тойрох (production build-д орохгүй)
if (process.env.NODE_ENV === 'development') {
  require('./devApiShim');
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
